<template>
  <div class="make-vocality-card" :class="{'male': vocality.sex == 'Male'}">
    <div class="action">
      <el-form ref="form" label-width="80px">
        <el-form-item :label="$t('upgrade_page_views_make_vocality_card_index_2063')">
          <el-radio v-model="vocality.sex" label="Male" @change="selectSex">{{$t('filters_index_79')}}</el-radio>
          <el-radio v-model="vocality.sex" label="Female" @change="selectSex">{{$t('filters_index_80')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('upgrade_page_views_make_vocality_card_index_2064')">
          <el-select
            v-model="vocality.voiceType"
            clearable
            :placeholder="$t('upgrade_page_views_make_vocality_card_index_2065')"
            @change="selectVoiceType"
          >
            <el-option
              v-for="(item,index) in options"
              :key="item.value+index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" class="btn-download" @click="download"
            >{{$t('upgrade_page_views_make_vocality_card_index_2066')}}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div ref="main" class="main" :class="{ male: vocality.sex == 'Male' }">
      <img class="avatar" :src="avatarUrl" alt="" />
      <div class="right">
        <div class="user-name">{{ userName }}</div>
        <div class="voice-type">{{ vocality.voiceType }}</div>
        <div class="score">
          <div>{{ vocality.totalRating }}</div>
          <div>{{ vocality.mainTone }}</div>
          <div class="tones">
            <div
              class="tones-item"
              v-for="(item, index) of vocality.secondaryTones"
              :key="index"
            >
              {{ item }} 10%
            </div>
          </div>
        </div>

        <div class="voice-partner-type">{{ vocality.voicePartnerType }}</div>
        <div class="score2">
          <div>{{ vocality.marketValue }}</div>
          <div>{{ vocality.allureValue }}</div>
          <div>{{ vocality.activityValue }}</div>
          <div>{{ vocality.heartbeatValue }}</div>
        </div>
      </div>
      <div class="uuid">{{ uuid }}</div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';
import domtoimage from 'dom-to-image';
export default {
  name: 'MakeVocalityCard',
  props: {},
  data() {
    return {
      vocality: {
        userName: i18n.t('upgrade_page_views_make_vocality_card_index_2067'),
        sex: 'Female',
        voiceType: i18n.t('upgrade_page_views_make_vocality_card_index_2068'),
        totalRating: '97',
        mainTone: i18n.t('upgrade_page_views_make_vocality_card_index_2069'),
        secondaryTones: [i18n.t('upgrade_page_views_make_vocality_card_index_2070'), i18n.t('upgrade_page_views_make_vocality_card_index_2071'), i18n.t('upgrade_page_views_make_vocality_card_index_2072')],
        voicePartnerType: i18n.t('upgrade_page_views_make_vocality_card_index_2073'),
        marketValue: '9.3',
        allureValue: '9.6',
        activityValue: '9.2',
        heartbeatValue: '9.8',
        uuid: '1000816'
        // soundDesignerName: 'Serena'
      },
      femaleList: [
        i18n.t('upgrade_page_views_make_vocality_card_index_2074'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2075'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2076'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2077'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2078'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2068'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2079'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2080'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2081'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2082'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2083')
      ],
      maleList: [
        i18n.t('upgrade_page_views_make_vocality_card_index_2084'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2085'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2086'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2087'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2086'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2087'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2088'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2089'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2090'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2086'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2091')
      ],
      voicePartnerTypeList: [
        i18n.t('upgrade_page_views_make_vocality_card_index_2092'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2093'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2094'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2095'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2096'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2097'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2098'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2099'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2100'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2101'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2102'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2103'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2104'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2105'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2106'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2107'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2108'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2109'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2110'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2111'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2112'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2113'),
        i18n.t('upgrade_page_views_make_vocality_card_index_2114')
      ]
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['userInfo', 'token', 'refreshToken']),
    // 是否已登录状态
    isLogined() {
      return this.userInfo && (this.token || this.refreshToken);
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    avatarUrl() {
      return this.userInfo ? this.userInfo.avatarUrl : '';
    },
    userName() {
      return this.userInfo ? this.userInfo.nickname : '';
    },
    sex() {
      return this.userInfo ? this.userInfo.sex : '';
    },
    options() {
      let list =
        this.vocality.sex === 'Female' ? this.femaleList : this.maleList;
      return list.map(item => {
        return {
          label: item,
          value: item
        };
      });
    }
  },
  methods: {
    getRandomNumber(randomType) {
      if (randomType === 1) {
        return (Math.random() * (9.9 - 9.0) + 9.0).toFixed(1);
      }
      if (randomType === 2) {
        return Math.random() * (100 - 90) + 90;
      }
      if (randomType === 3) {
        return Math.floor(Math.random() * (100 - 90 + 1)) + 90;
      }
    },

    getRandomItems(arr, n) {
      let result = new Array(n),
        len = arr.length,
        taken = new Array(len);
      if (n > len) {
        throw new RangeError('getRandom: more elements taken than available');
      }
      while (n--) {
        let x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },

    selectSex() {
      console.log(this.options[0].value);
      
      this.vocality.voiceType = this.options[0].value;
      this.selectVoiceType()
    },

    selectVoiceType() {
      const index = this.options.findIndex(item => {
        return item.value === this.vocality.voiceType;
      });
      this.vocality.totalRating = this.getRandomNumber(3);
      this.vocality.mainTone = this.vocality.voiceType + i18n.t('upgrade_page_views_make_vocality_card_index_2115');
      this.vocality.secondaryTones = this.getRandomItems(
        this.voicePartnerTypeList,
        3
      );
      this.vocality.voicePartnerType =
        this.vocality.sex === 'Female'
          ? this.maleList[index] + '音'
          : this.femaleList[index] + i18n.t('upgrade_page_views_make_vocality_card_index_2116');
      console.log(
        index,
        this.maleList[index] + '音',
        this.vocality.sex === 'Female'
      );

      this.vocality.marketValue = this.getRandomNumber(1);
      this.vocality.allureValue = this.getRandomNumber(1);
      this.vocality.activityValue = this.getRandomNumber(1);
      this.vocality.heartbeatValue = this.getRandomNumber(1);
    },
    // 檢查登入
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    async download() {
      await this.checkLogin();
      domtoimage.toPng(this.$refs.main).then(function(dataUrl) {
        let link = document.createElement('a');
        link.download = 'make-vocality-card.png';
        link.href = dataUrl;
        link.click();
      });
    }
  },
  created() {
    this.selectVoiceType();
  }
};
</script>
<style lang="scss" scoped>
.make-vocality-card {
  display: flex;
  padding: 40px;
  width: 100%;
  overflow: auto;
  line-height: 1;
  color: #eb5e9d;
  &.male {
    color: #65b4ff;
  }
}
.action {
  padding: 20px;
}
.main {
  width: 1079px;
  height: 1112px;
  background-image: url('./images/female.png');
  display: flex;
  padding: 88px 0 0 77px;
  font-size: 24px;
  position: relative;
  &.male {
    background-image: url('./images/male.png');
  }
  .avatar {
    width: 327px;
    height: 327px;
    object-fit: cover;
    flex: none;
  }
  .right {
    flex: none;
  }
  .user-name {
    font-size: 38px;
    margin: 57px 0 0 160px;
  }
  .voice-type {
    font-size: 38px;
    margin: 47px 0 0 275px;
    color: white;
    width: 228px;
    text-align: center;
  }
  .score {
    margin: 88px 0 0 316px;
    > div {
      margin-bottom: 48px;
    }
    .tones {
      margin-top: 48px;
    }
    .tones-item {
      margin-bottom: 16px;
    }
  }
  .voice-partner-type {
    margin: 56px 0 0 316px;
  }
  .score2 {
    display: flex;
    flex-wrap: wrap;
    width: 513px;
    margin-left: 246px;
    margin-top: 131px;
    div {
      width: 252px;
      margin-bottom: 42px;
    }
  }
  .uuid {
    position: absolute;
    bottom: 61px;
    left: 387px;
  }
  //   .btn-download {
  //     margin-top: 30px;
  //   }
}
</style>
